import React from "react";

import phoneIcon from "./assets/phone1-icon.png";
import mailIcon from "./assets/mail1-icon.png";
import locationIcon from "./assets/location-icon.png";
import gridBg from "./assets/grid-bg1.webp";

const HeroSection = () => {
  return (
    <>
      <section
        className="pt-20 pb-36 bg-fullcover bg- text-white"
        style={{ backgroundImage: `url(${gridBg})` }}
      >
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-4">We’d love to help you</h2>
          <p className="text-lg text-gray-100 max-w-2xl mx-auto">
            Please feel free to get in touch using the form below. We'd love to
            hear your thoughts & answer any questions you may have!
          </p>
        </div>
      </section>

      {/* Light Blue Section Wrap with Cards Inside */}
      <section className="relative z-6 -mt-24">
        <div className="max-w-7xl mx-auto px-4">
          <div className="relative z-10 max-w-6xl mx-auto px-4">
            <div className="bg-white rounded-2xl shadow-2xl px-6 py-10">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Card 1 */}
                <div className="bg-[#f1f5f9] border border-[#D2DBE8] rounded-xl p-6 shadow-md">
                  <img
                    src={phoneIcon}
                    alt="Phone Icon"
                    className="w-10 h-10 mb-4"
                  />
                  <h3 className="text-lg font-semibold text-[#131519] mb-2">
                    Make a call
                  </h3>
                  <p className="text-[#4e5a6a] mb-4">
                    Let’s talk with our experts
                  </p>
                  <a
                    href="tel:+914448563345"
                    className="text-green-700 font-bold text-lg hover:underline"
                  >
                    +91-44-4856-3345
                  </a>
                </div>

                {/* Card 2 */}
                <div className="bg-[#f1f5f9] border border-[#D2DBE8] rounded-xl p-6 shadow-md">
                  <img
                    src={mailIcon}
                    alt="Mail Icon"
                    className="w-10 h-10 mb-4"
                  />
                  <h3 className="text-lg font-semibold text-[#131519] mb-2">
                    Send a mail
                  </h3>
                  <p className="text-[#4e5a6a] mb-4">Don't hesitate to mail</p>
                  <div className="space-x-2">
                    <a
                      href="mailto:info@lenteratech.com"
                      className="bg-white text-blue-900 px-7 py-2 rounded-full text-sm font-medium hover:underline"
                    >
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                {/* Card 3 */}
                <div className="bg-[#f1f5f9] border border-[#D2DBE8] rounded-xl p-6 shadow-md">
                  <img
                    src={locationIcon}
                    alt="Location Icon"
                    className="w-10 h-10 mb-4"
                  />
                  <h3 className="text-lg font-semibold text-[#131519] mb-2">
                    Address
                  </h3>
                  <a
                    href="https://www.google.com/maps/place/G1,+Plot+No,+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-700 font-medium text-sm hover:underline block"
                  >
                    G1, Plot No, 824 and 826, 3rd Main Rd, Ram Nagar South,
                    Madipakkam, Chennai, Tamil Nadu 600091.
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Extra Bottom Padding */}
      <div className="pb-20"></div>
    </>
  );
};

export default HeroSection;
